import { render, staticRenderFns } from "./CotizaHub.vue?vue&type=template&id=3c856bae&scoped=true"
import script from "./CotizaHub.vue?vue&type=script&lang=js"
export * from "./CotizaHub.vue?vue&type=script&lang=js"
import style0 from "./CotizaHub.vue?vue&type=style&index=0&id=3c856bae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c856bae",
  null
  
)

export default component.exports